(function () {
  'use strict'

  require('./scss/module-ugc.scss')

  var MODULE_NAME = 'thismoment.glow.component.module.ugc'
  var templateUrl = require('./tpl/module-ugc.html')

  require('dynamic-bind-html') // ಠ_ಠ

  require('angular')
    .module(MODULE_NAME, [
      'dynamicBindHtml',
      require('./component/ugc-modal'),
      require('./component/ugc-page'),
      require('../../../../common/formly/inputs/email-validate'),
      require('../../../../common/formly/inputs/phone-validate'),
      require('../../../../common/formly/inputs/address-autocomplete')
    ])
    .component('thismomentGlowModuleUgc', {
      templateUrl: templateUrl,
      bindings: {
        moduleId: '<',
        name: '<',
        displayForm: '<'
      },
      controller: glowUgcController
    })

  glowUgcController.$inject = []
  function glowUgcController () {
    var vm = this

    vm.$onInit = ugcInit

    function ugcInit () {
      if (vm.displayForm === 'page') {
        vm.isPage = true
      } else if (vm.displayForm === 'js') {
        vm.isJs = true
      } else {
        vm.isModal = true
      }
    }
  }

  module.exports = MODULE_NAME
})()



// WEBPACK FOOTER //
// ./src/glow/component/glow-module/module-ugc/index.js